import BucketApiRequest from "./BucketApiRequest";
import { GET_FUND_PAYMENT_DETAILS_URL } from "../ApiUrls";

export default class FundPaymentDetailsApiRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_FUND_PAYMENT_DETAILS_URL;
  };
}
